import React from 'react';
import { withStyles} from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next';
import HomeworkGroupTile from './HomeworkGroupTile';

const styles = theme => ({
  entry: {
    marginTop: 20,
    marginBottom: 20,
  },
});

class HomeworkGroupTiles extends React.Component {
  render() {
    const {
      classes,
      entries,
      onEntryClick,
      reloadHomeworkData,
    } = this.props;

    return (
      <div className="homework-group-tiles">
        {entries.map((entry) => {
          return (
            <div
              key={entry.id}
              className={classes.entry}
            >
              <HomeworkGroupTile
                data={entry}
                dateFormat={dateFormat}
                onDetailsButtonClick={onEntryClick}
                onHomeworkChecked={reloadHomeworkData}
                useSuspense={false}
              />
            </div>
          );
        })}
      </div>
    );
  }
}

export default withStyles(styles)(withTranslation()(HomeworkGroupTiles));
